var map = {
	"./ion-accordion_2.entry.js": [
		8386,
		8592,
		8386
	],
	"./ion-action-sheet.entry.js": [
		9355,
		8592,
		9355
	],
	"./ion-alert.entry.js": [
		7979,
		8592,
		7979
	],
	"./ion-app_8.entry.js": [
		1665,
		8592,
		1665
	],
	"./ion-avatar_3.entry.js": [
		1458,
		1458
	],
	"./ion-back-button.entry.js": [
		524,
		8592,
		524
	],
	"./ion-backdrop.entry.js": [
		4393,
		4393
	],
	"./ion-breadcrumb_2.entry.js": [
		1564,
		8592,
		1564
	],
	"./ion-button_2.entry.js": [
		4595,
		2360
	],
	"./ion-card_5.entry.js": [
		9027,
		9027
	],
	"./ion-checkbox.entry.js": [
		3974,
		8592,
		3974
	],
	"./ion-chip.entry.js": [
		1813,
		1813
	],
	"./ion-col_3.entry.js": [
		5700,
		5700
	],
	"./ion-datetime-button.entry.js": [
		651,
		2038,
		651
	],
	"./ion-datetime_3.entry.js": [
		4429,
		2038,
		8592,
		4429
	],
	"./ion-fab_3.entry.js": [
		6118,
		8592,
		6118
	],
	"./ion-img.entry.js": [
		5633,
		5633
	],
	"./ion-infinite-scroll_2.entry.js": [
		5436,
		8592,
		5436
	],
	"./ion-input.entry.js": [
		5831,
		8592,
		5831
	],
	"./ion-item-option_3.entry.js": [
		5769,
		8592,
		5769
	],
	"./ion-item_8.entry.js": [
		3250,
		8592,
		3250
	],
	"./ion-loading.entry.js": [
		4489,
		4489
	],
	"./ion-menu_3.entry.js": [
		505,
		8592,
		505
	],
	"./ion-modal.entry.js": [
		684,
		8592,
		684
	],
	"./ion-nav_2.entry.js": [
		5694,
		8592,
		5694
	],
	"./ion-picker-column-internal.entry.js": [
		9358,
		8592,
		9358
	],
	"./ion-picker-internal.entry.js": [
		9067,
		9067
	],
	"./ion-popover.entry.js": [
		314,
		314
	],
	"./ion-progress-bar.entry.js": [
		9433,
		9433
	],
	"./ion-radio_2.entry.js": [
		9212,
		8592,
		9212
	],
	"./ion-range.entry.js": [
		1316,
		8592,
		1316
	],
	"./ion-refresher_2.entry.js": [
		315,
		8592,
		315
	],
	"./ion-reorder_2.entry.js": [
		8702,
		8592,
		9320
	],
	"./ion-ripple-effect.entry.js": [
		5239,
		5239
	],
	"./ion-route_4.entry.js": [
		4005,
		4005
	],
	"./ion-searchbar.entry.js": [
		5777,
		8592,
		5777
	],
	"./ion-segment_2.entry.js": [
		8235,
		8592,
		8235
	],
	"./ion-select_3.entry.js": [
		9578,
		8592,
		4315
	],
	"./ion-spinner.entry.js": [
		3714,
		8592,
		3714
	],
	"./ion-split-pane.entry.js": [
		8690,
		8690
	],
	"./ion-tab-bar_2.entry.js": [
		4125,
		8592,
		4125
	],
	"./ion-tab_2.entry.js": [
		976,
		976
	],
	"./ion-text.entry.js": [
		4476,
		4476
	],
	"./ion-textarea.entry.js": [
		1422,
		8592,
		1422
	],
	"./ion-toast.entry.js": [
		9099,
		9099
	],
	"./ion-toggle.entry.js": [
		9775,
		8592,
		9775
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5821;
module.exports = webpackAsyncContext;